<form #form="ngForm" novalidate>
  @for (certificate of certificates; track certificate; let certificateIndex = $index) {
  <mat-card appearance="outlined" class="mb-4 mat-sub-card" ngModelGroup="{{ certificate.__cid }}">
    <mat-card-title>Certificato {{ certificate.id ? certificate.name : 'Aggiuntivo ' }}</mat-card-title>
    <mat-card-content>
      @if (_isReadonly) {
      <mat-list-item>
        <h3 matLine>Tipo</h3>
        <p matLine>{{ certificate.type }}</p>
      </mat-list-item>
      } @if (!_isReadonly) {
      <mat-form-field class="w-100">
        <mat-label>Tipo</mat-label>
        <mat-select [(ngModel)]="certificate.type" (selectionChange)="loadCertificates(certificate.type)" required name="type">
          <mat-option [value]="undefined">Seleziona</mat-option>
          @for (certificateType of certificateTypes; track certificateType) {
          <mat-option [value]="certificateType.id" [disabled]="isAlreadySelected(certificateType)">
            {{ certificateType.name }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      } @if (!_isReadonly) {
      <app-form-control-error [form]="form" control="type"></app-form-control-error>
      } @if (certificate.type) {
      <div>
        @if (_isReadonly) {
        <mat-list-item>
          <h3 matLine>Certificato</h3>
          <p matLine>{{ certificate.name }}</p>
        </mat-list-item>
        } @if (!_isReadonly) {
        <mat-form-field class="w-100">
          <mat-label>Certificato</mat-label>
          <mat-select [(ngModel)]="certificate.id" name="certificateId" required>
            <mat-option [value]="undefined">Seleziona</mat-option>
            @for (_certificate of crts[certificate.type]; track _certificate) {
            <mat-option [value]="_certificate.id">
              {{ _certificate.name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        } @if (!_isReadonly) {
        <app-form-control-error [form]="form" control="certificateId"></app-form-control-error>
        }
      </div>
      }
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-icon-button (click)="removeCertificate(certificateIndex)">
        <mat-icon>delete</mat-icon>
      </button>
    </mat-card-actions>
  </mat-card>
  } @if (canManageCertificates && !_isReadonly) {
  <div class="d-flex align-items-center pt-3 justify-content-end">
    <button mat-flat-button type="button" color="accent" (click)="addCertificate()" [disabled]="!canAddCertificate">
      Associa Certificato
    </button>
    <ng-content select="[certificateManagementActions]"></ng-content>
  </div>
  }
</form>
